<h1 mat-dialog-title>¿Deseas agregar intereses?</h1>

<div mat-dialog-content>
  <form [formGroup]="interestsForm" (ngSubmit)="onSubmit()">
    <mat-form-field appearance="fill">
      <mat-label>Valor de los intereses</mat-label>
      <input
        matInput
        formControlName="interestAmount"
        type="number"
        placeholder="Ingrese un valor numérico"
        min="0"
        (keypress)="onlyNumbers($event)"
        (paste)="blockPasteNegative($event)"
      />

      <mat-error *ngIf="interestsForm.get('interestAmount')?.hasError('required')">
        El monto de interés es requerido
      </mat-error>
      <mat-error *ngIf="interestsForm.get('interestAmount')?.hasError('min')">
        El monto de interés debe ser mayor o igual a 0
      </mat-error>
    </mat-form-field>
  </form>
</div>

<div mat-dialog-actions>
  <button mat-button (click)="onNoClick()">Cerrar</button>
  <button mat-button [disabled]="!interestsForm.valid" (click)="onSubmit()">Enviar</button>
</div>
